
import {
    TextField } from "../ui";
import SnpButton from "./SnpButton"; // your custom button
import { useEffect } from "react";
import {
  printDebugLog
} from "../../constants/constant";

function CouponApply({ isPaid, isRoleAllowed, coupon, appliedCoupon, setCoupon, handleApply, handleRemove }) {


    useEffect(() => {
        printDebugLog("CouponApply", coupon, appliedCoupon);
    }, [coupon, appliedCoupon])

    return (
        <div
            style={{
                display: "flex",
                gap: "8px",
                marginTop: "8px",
                alignItems: "center",
            }}
        >
            {appliedCoupon ? (
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                        padding: "6px 10px",
                        borderRadius: "6px",
                        background: "#f3f4f6",
                        border: "1px solid #ddd",
                        fontWeight: 500,
                    }}
                >
                    <span>
                        <span style={{ color: "green", fontStyle: "italic", fontSize: "0.9em", fontFamily: "cursive" }}>
                            Applied:
                        </span>{" "}
                        <span style={{ fontWeight: "bold", fontSize: "1em", fontFamily: "monospace" }}>{coupon}</span>
                    </span>
                    {
                        !isPaid && <button
                            onClick={handleRemove}
                            style={{
                                border: "none",
                                background: "transparent",
                                cursor: "pointer",
                                fontSize: "16px",
                                fontWeight: "bold",
                                lineHeight: 1,
                                color: "#444",
                            }}
                            aria-label="Remove coupon"
                        >
                            ×
                        </button>
                    }

                </div>
            ) : (
                <>
                    <TextField
                        id="coupon"
                        name="coupon"
                        variant="filled"
                        size="small"
                        disabled={isPaid || !isRoleAllowed}
                        label="Enter coupon Code"
                        style={{ flex: 1 }}
                        value={coupon}
                        onChange={(e) => setCoupon(e.target.value)}
                    />
                    {!(isPaid || !isRoleAllowed) && (
                        <SnpButton
                            variant="contained"
                            color="primary"
                            onClick={handleApply}
                            style={{
                                cursor:
                                    isPaid || !isRoleAllowed ? "not-allowed" : "pointer",
                            }}
                        >
                            Apply
                        </SnpButton>
                    )}
                </>
            )}
        </div>
    );
}

export default CouponApply;
